module.exports = __webpack_public_path__ + "static/icons/icon-map--france-0ca0cda0f92d3bee96d27ae3b5b0c64a.svg";